import * as React from "react"
import Svg, { Path } from "react-native-svg"

const LogoutIcon = (props) => (
    <Svg
        width={16}
        height={17}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M4.405 11.5 1.5 8.5l2.905-3M1.5 8.5h9M4.5 1.5l8 .002c1.104.001 2 .896 2 2v9.995c0 1.104-.896 2-2 2l-8 .003"
            stroke="#000"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
)

export default LogoutIcon
